import React from "react";
import { Edit2, Trash2 } from "lucide-react";

const OPTIONS = ["A", "B", "C", "D"];
const OPTION_KEYS = ["option1", "option2", "option3", "option4"];

const QuestionCard = ({ question, index, onEdit, onDelete }) => {
  return (
    <div className="rounded-2xl border border-white/10 bg-bgSecondary dark:glass-effect shadow-sm hover:shadow-md transition-shadow duration-200 p-5 space-y-3">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-semibold text-textHeading shrink-0">Q{index + 1}</p>
        <p className="flex-1 text-sm font-medium dark:text-gray-200 text-textPrimary leading-relaxed">
          {question.question}
        </p>
        <div className="flex items-center gap-1 shrink-0">
          {onEdit && (
            <button
              onClick={onEdit}
              className="p-1.5 rounded-lg hover:bg-blue-500/10 text-blue-400 transition-colors"
              title="Edit question"
            >
              <Edit2 size={14} />
            </button>
          )}
          {onDelete && (
            <button
              onClick={onDelete}
              className="p-1.5 rounded-lg hover:bg-red-500/10 text-red-400 transition-colors"
              title="Delete question"
            >
              <Trash2 size={14} />
            </button>
          )}
        </div>
      </div>

      <div className="space-y-1.5 pl-6">
        {OPTION_KEYS.map((key, i) => {
          const optionText = question[key];
          const isCorrect = optionText === question.answer;
          return (
            <div
              key={key}
              className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm transition-colors ${
                isCorrect
                  ? "bg-emerald-500/10 border border-emerald-400/40 text-emerald-400"
                  : "bg-bgPrimary border border-white/5 dark:text-gray-400 text-textSecondary"
              }`}
            >
              <span className={`font-semibold shrink-0 w-4 text-center ${isCorrect ? "text-emerald-400" : "text-textSecondary dark:text-gray-500"}`}>
                {OPTIONS[i]}
              </span>
              <span className="flex-1">{optionText}</span>
              {isCorrect && (
                <span className="text-xs font-semibold text-emerald-400 ml-auto shrink-0">
                  ✓ Correct
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;
